import { useCallback, useEffect, useState } from 'react';
import { DataGridProProps, GridPaginationModel } from '@mui/x-data-grid-pro';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { IGroupSFilter } from 'src/@types/SearchFilterTypes';
import CDataGridPro from 'src/components/CDataGridPro';
import useGetGridCol, { IGroupGridRow } from 'src/hooks/useGetGridCol';
import { ContentBox } from 'src/layouts/form/FormButton';
import { IGroup } from 'src/models';
import { INIT_PAGINATION, IPagination } from 'src/models/extensions/withPagination';
import { groupApi } from 'src/service';

interface IGroupGridProps extends Omit<DataGridProProps, 'columns'> {
  searchData?: Partial<IGroupSFilter>;
}

export const MenuGroupGrid = ({ searchData, ...props }: IGroupGridProps) => {
  const { getMenuGroupGridCol } = useGetGridCol();
  const [gridRows, setGridRows] = useState<IGroupGridRow[]>([]);
  const [pagination, setPagination] = useState<IPagination>(INIT_PAGINATION);

  // 목록 조회
  const getGroupData = useCallback(async () => {
    const pageParams = {
      ...searchData,
      page: pagination.page,
      size: pagination.size,
    };
    const result = await groupApi.getGroups(pageParams);
    if (result) {
      const newGridRows = result.data.map((group: IGroup, i: number) => {
        return { ...group, id: group.oprtrGroupSid ?? i };
      });
      setGridRows(newGridRows);
      if (result.pagination) {
        setPagination(result.pagination);
      }
    }
  }, [searchData, pagination.page, pagination.size]);

  useEffect(() => {
    getGroupData();
  }, [getGroupData, pagination.page, pagination.size]);

  // 페이지 모델 변경 시
  const handlePaginationModelChange = (paginationModel: GridPaginationModel) => {
    setPagination({
      ...pagination,
      page: paginationModel.page + 1,
      size: paginationModel.pageSize,
    });
    getGroupData();
  };
  return (
    <ContentBox>
      <CDataGridPro
        columns={getMenuGroupGridCol()}
        rows={gridRows}
        rowCount={toJS(pagination.totalElements)}
        paginationModel={{
          page: pagination.page - 1,
          pageSize: pagination.size,
        }}
        onPaginationModelChange={handlePaginationModelChange}
        slots={{ footer: () => null }}
        isRowSelectable={(params) => !params.row.wthdYn}
        {...props}
      />
    </ContentBox>
  );
};

export default observer(MenuGroupGrid);
